import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n';

import { getRouteByName } from 'Helpers/Routes';
import { forceHttpsUri } from 'Helpers/Uri';
import { selectCaption } from 'Helpers/Photos';
import { shortenString } from 'Helpers/String';

import Spinner from 'Components/layout/Spinner';

export default class CartItemsList extends React.Component {
    static propTypes = {
        onRemoveItem: PropTypes.func.isRequired,
        isLoading: PropTypes.bool.isRequired,
        hidePrices: PropTypes.bool.isRequired,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                loading: PropTypes.bool,
                resolutions: PropTypes.shape({
                    w640: PropTypes.string.isRequired
                }),
                selectedCaption: PropTypes.string,
                width: PropTypes.number,
                height: PropTypes.number,
                price: PropTypes.number,
                license: PropTypes.string
            })
        )
    };
    static defaultProps = {};

    renderList = items => {
        return items.map(item => {
            let license = '...';
            if (item.license) {
                if (item.license.toLowerCase() === 'editorial') {
                    license = I18n.t('SINGLE_PHOTO.checkout.licenses.editorial');
                } else {
                    license = I18n.t('SINGLE_PHOTO.checkout.licenses.commercial');
                }
            }

            return (
                <div className="cart-item clearfix" key={item.id}>
                    {item.hasOwnProperty('loading') && item.loading ? <Spinner /> : null}
                    <div className="cart-item-photo-col">
                        <Link to={getRouteByName('singlePhoto', { slug: item.id }).path} target="_blank">
                            <figure className="cart-item-photo" style={{ backgroundImage: `url(${item.resolutions ? forceHttpsUri(item.resolutions.w640) : require('./images/placeholder.jpg')})` }} ></figure>
                        </Link>
                    </div>
                    <div className="cart-item-details-col">
                        <div className="cart-item-details-row">
                            <div className="cart-item-details-data-col">
                                <h4 className="cart-item-data-caption">{shortenString(selectCaption(item), 50, true) || '...'}</h4>
                                <div className="cart-item-data-list">
                                    <p><small>Size: </small>{item.width} x {item.height}</p>
                                    <p><small>Format: </small>JPG</p>
                                    <p><small>License: </small>{license}</p>
                                </div>
                            </div>
                            {this.props.hidePrices ? null :
                                <div className="cart-item-details-price-col">
                                    <h4 className="cart-item-data-price"><small className="mobile">Price: </small>$ {item.price ? parseFloat(item.price).toFixed(2) : '--'}</h4>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="cart-item-controls-col">
                        <a className="cart-item-control-remove" onClick={() => this.props.onRemoveItem(item)}>Remove</a>
                    </div>
                </div >
            );
        });
    }

    render() {
        const { items, isLoading } = this.props;

        if (isLoading) {
            return (
                <div className="component-cart-items-list">
                    <Spinner className="relative" />
                </div>
            );
        } else {
            return (
                <div className="component-cart-items-list">
                    {items.length ?
                        this.renderList(items) :
                        <div className="cart-items-list-empty">
                            <img className="no-results-icon" src={require('./images/no-results-icon.png')} />
                            <h3 className="no-results-headline">Your cart is empty...</h3>
                        </div>
                    }
                </div>
            );
        }

    }
}



// WEBPACK FOOTER //
// ./src/components/public/cart/ItemsList/index.js